import React from 'react';
import MetricLoader from '../MetricLoader';
import DeltaMetric from '../DeltaMetric';
import {useEventsContext} from '@/pages/dashboard/EventsContext';

export default function TotalYear(props) {
  const {titleOnly} = props;
  const {filteredEvents, isLoading} = useEventsContext();

  if (isLoading) {
    return (
      <MetricLoader
        name="Total"
      />
    );
  }

  return (
    <DeltaMetric
      name="Total"
      value={filteredEvents.length}
      delta={0}
      titleOnly={titleOnly}
    />
  );
}
